import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const InfraContainer = styled.aside`
    width: 100%;
    padding: 2%;
    margin-top: ${props => props.mt}%;

    .swiper{
        width: 65%;
        padding: 2% 0;
        margin: 0 auto;
        border-radius: 25px;

        .swiper-pagination{
            bottom: 0;

            &-bullet-active{
                border: 1px solid ${Colors.white};
                background: ${Colors.orange};
            }
        }

        .swiper-slide{
            height: 485px;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        margin-top: -25%;
        .swiper{
            width: 80%;
            border-radius: 20px;
        }
    }
`;

export const InfraImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 25px;
`;